<div>
    <ul class="list-group" *ngFor="let value of folder.sub_folders">
        <a class="list-group-item list-group-item-warning">
            <span [ngStyle]="{'padding-left': value.indent*15}">{{value.name | translateHs : {module:
                'LAYERMANAGER'} }}</span>
        </a>
        <li [hidden]="!(value.sub_folders.length > 0)">
            <hs-layer-manager-folder [folder]="value"></hs-layer-manager-folder>
        </li>
        <li>
            <hs-layermanager-layer-list [folder]="value"></hs-layermanager-layer-list>
        </li>
    </ul>
</div>